module.exports = __webpack_public_path__ + "assets/img/deliLogin.24d2157f.png";